// Headline.jsx
import React from 'react'
import PropTypes from 'prop-types'

import styles from '../../../../css/devicePage.module.css'
import colors from '../../../../css/colors.module.css'

const Headline = function Headline ({ info, prepend }) {
  if (!info || typeof info === 'undefined' || !info.enabled || info.text.length < 1) {
    return ''
  }

  let color = colors.normal
  switch (info.color) {
    case 'deviceProblem':
      color = colors.deviceProblem
      break
    case 'danger':
      color = colors.danger
      break
    case 'warning':
      color = colors.warning
      break
    case 'success':
      color = colors.success
      break
    case 'disconnected':
      color = colors.disconnected
      break
    case 'info':
      color = colors.info
      break
    default:
      color = colors.normal
  }

  let returnText = ''
  for (let i = 0; i < info.text.length; i++) {
    returnText += info.text[i]
    if (i + 1 === info.text.length) {

    } else {
      returnText += ', '
    }
  }

  return (
    <section>
      <div className={styles.tileContainer}>
        <button type='button' className={`${styles.headlineContainer} ${color}`}>
          <div className={styles.tile}>
            <h5 className={styles.headline}>
              {prepend}
              <br />
              {returnText}
            </h5>
          </div>
        </button>
      </div>
    </section>
  )
}
Headline.propTypes = {
  info: PropTypes.object,
  prepend: PropTypes.string,
}

export default Headline
